import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { api } from "src/shared/setup/API/api";

export const UseBalancePiesADM = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const { filterHome, setValuesBalancePiesADM } = useMetricsContext();

  const handleSubmit = () => {
    api
      .get(
        `/metrics/producao-administradora?start_date=${filterHome.startDate}
        &end_date=${filterHome.endDate}
        &is_received=TRUE`
      )
      .then(({ data }) => setValuesBalancePiesADM(data.data))
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      );
  };

  return { handleSubmit };
};
